import { useState, useEffect } from "react";
import { api, errMsg } from "../../lib/api";
import { Trash2, CornerDownRight } from "lucide-react";
import { toast } from "sonner";

export default function AdminQA() {
  const [qs, setQs] = useState([]);
  const [tab, setTab] = useState("unanswered");
  const [reply, setReply] = useState({});
  const load = () => api.get("/admin/questions").then((r) => setQs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const answer = async (q) => {
    const text = (reply[q.id] || "").trim();
    if (!text) return;
    try {
      await api.post(`/admin/questions/${q.id}/answer`, { text });
      toast.success("Answer posted ✓");
      setReply((r) => ({ ...r, [q.id]: "" }));
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this question?")) return;
    await api.delete(`/admin/questions/${id}`);
    toast.success("Question deleted");
    load();
  };

  const unanswered = qs.filter((q) => !q.answer);
  const shown = tab === "unanswered" ? unanswered : qs;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display font-bold text-xl" data-testid="admin-qa-title">STUDENT Q&A</h1>
        <div className="flex gap-1">
          {[["unanswered", `Unanswered (${unanswered.length})`], ["all", `All (${qs.length})`]].map(([k, label]) => (
            <button key={k} data-testid={`qa-tab-${k}`} onClick={() => setTab(k)}
              className={`text-xs font-display px-3 py-1.5 rounded border transition-colors ${tab === k ? "border-[var(--forge-blue)] text-[var(--forge-blue)]" : "border-[var(--forge-border)] text-[var(--forge-dim)]"}`}>
              {label}
            </button>
          ))}
        </div>
      </div>
      {shown.length === 0 && (
        <div className="empty" data-testid="qa-empty-admin">
          {tab === "unanswered" ? "All caught up — no unanswered questions. 🎉" : "No questions from students yet."}
        </div>
      )}
      <div className="space-y-3">
        {shown.map((q) => (
          <div key={q.id} className="forge-card !transform-none p-4" data-testid={`admin-qa-${q.id}`}>
            <div className="flex items-center gap-2 text-xs" style={{ color: "var(--muted)" }}>
              <span className="font-semibold" style={{ color: "var(--bp)" }}>{q.course_title}</span>
              <span>›</span>
              <span>{q.lecture_title}</span>
              <span className="ml-auto">{new Date(q.created_at).toLocaleString()}</span>
              <button data-testid={`qa-delete-${q.id}`} onClick={() => remove(q.id)} className="p-1 hover:text-red-400"><Trash2 size={13} /></button>
            </div>
            <p className="text-sm mt-2"><b>{q.user_name}:</b> {q.text}</p>
            {q.answer ? (
              <div className="mt-2 pl-3 py-1.5 text-sm" style={{ borderLeft: "2px solid var(--gold)" }}>
                <span className="font-display text-[10px] font-bold" style={{ color: "var(--gold)", letterSpacing: 1.5 }}>YOUR ANSWER</span>
                <p className="whitespace-pre-line mt-0.5">{q.answer}</p>
              </div>
            ) : (
              <div className="flex gap-2 mt-3">
                <input data-testid={`qa-reply-input-${q.id}`} value={reply[q.id] || ""}
                  onChange={(e) => setReply((r) => ({ ...r, [q.id]: e.target.value }))}
                  onKeyDown={(e) => { if (e.key === "Enter") answer(q); }}
                  placeholder="Write your reply…" className="input-dark text-sm flex-1" />
                <button data-testid={`qa-reply-btn-${q.id}`} onClick={() => answer(q)}
                  className="btn-primary !py-2 text-sm flex items-center gap-1"><CornerDownRight size={14} /> REPLY</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
